module.exports = ":host {\n  display: inline-block; }\n  :host .face-image {\n    cursor: pointer; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/atoms/alg-face/alg-face.component.scss
// module id = ./src/app/components/atoms/alg-face/alg-face.component.scss
// module chunks = main